import { createFileRoute } from "@tanstack/react-router";
import { HsePage, hseHead } from "@/pages/HsePage";

export const Route = createFileRoute("/hse-ledelse")({
  head: () => hseHead("da"),
  component: () => <HsePage locale="da" />,
});
